import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo.svg';

const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/services', label: 'What We Do' },
  { to: '/our-work', label: 'Our Work' },
  { to: '/contact', label: 'Contact' },
];

export default function Navbar({ navLinks = NAV_LINKS }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location]);

  const isActive = (to) => location.pathname === to;

  return (
    <>
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
        padding: scrolled ? '10px 40px' : '18px 40px',
        background: scrolled ? 'rgba(12,18,34,0.95)' : 'transparent',
        backdropFilter: scrolled ? 'blur(24px)' : 'none',
        transition: 'all 0.4s cubic-bezier(0.4,0,0.2,1)',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        borderBottom: scrolled ? '1px solid var(--card-border)' : 'none',
      }}>
        <Link to="/">
          <img
            src={logo}
            alt="KnowIT Solutions"
            style={{
              height: scrolled ? 32 : 38,
              width: 'auto',
              transition: 'height 0.3s',
            }}
          />
        </Link>

        {/* Desktop nav */}
        <div className="desktop-nav" style={{ display: 'flex', gap: 32, alignItems: 'center' }}>
          {navLinks.map(l => (
            <Link
              key={l.to}
              to={l.to}
              style={{
                fontFamily: 'var(--font-body)', fontSize: '0.82rem',
                fontWeight: isActive(l.to) ? 600 : 400,
                color: isActive(l.to) ? 'var(--cyan)' : 'rgba(255,255,255,0.6)',
                letterSpacing: '0.07em', textTransform: 'uppercase',
                transition: 'color 0.3s', padding: '6px 0',
                borderBottom: isActive(l.to) ? '2px solid var(--cyan)' : '2px solid transparent',
                textDecoration: 'none',
              }}
            >
              {l.label}
            </Link>
          ))}
        </div>

        {/* Mobile hamburger */}
        <button
          className="mobile-menu-btn"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
          style={{
            display: 'none', background: 'none', border: 'none',
            cursor: 'pointer', flexDirection: 'column', gap: 5, padding: 8,
          }}
        >
          {[0, 1, 2].map(i => (
            <span key={i} style={{
              width: 24, height: 2, background: '#fff', display: 'block',
              transition: 'all 0.3s',
              ...(i === 0 && menuOpen ? { transform: 'rotate(45deg) translate(5px,5px)' } : {}),
              ...(i === 1 ? { opacity: menuOpen ? 0 : 1 } : {}),
              ...(i === 2 && menuOpen ? { transform: 'rotate(-45deg) translate(5px,-5px)' } : {}),
            }} />
          ))}
        </button>
      </nav>

      {/* Mobile overlay */}
      {menuOpen && (
        <div style={{
          position: 'fixed', inset: 0, zIndex: 999,
          background: 'rgba(12,18,34,0.98)',
          display: 'flex', flexDirection: 'column',
          justifyContent: 'center', alignItems: 'center', gap: 28,
        }}>
          {navLinks.map(l => (
            <Link
              key={l.to}
              to={l.to}
              style={{
                fontFamily: 'var(--font-body)', fontSize: '1.6rem', fontWeight: 700,
                color: isActive(l.to) ? 'var(--cyan)' : '#fff',
                textDecoration: 'none',
              }}
            >
              {l.label}
            </Link>
          ))}
        </div>
      )}

      {/* Responsive CSS */}
      <style>{`
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .mobile-menu-btn { display: flex !important; }
        }
        @media (min-width: 769px) {
          .mobile-menu-btn { display: none !important; }
        }
      `}</style>
    </>
  );
}
